module.exports = __webpack_public_path__ + "4018d5fb8bbc6808ea8fd4e2092d3903.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/rollerskates-pinkblue-s.png
// module id = 2531
// module chunks = 0